import { render, staticRenderFns } from "./ReceivedStatementReport.vue?vue&type=template&id=a554bf40&scoped=true"
import script from "./ReceivedStatementReport.vue?vue&type=script&lang=js"
export * from "./ReceivedStatementReport.vue?vue&type=script&lang=js"
import style0 from "./ReceivedStatementReport.vue?vue&type=style&index=0&id=a554bf40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a554bf40",
  null
  
)

export default component.exports